exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn{\n  min-width: 100%;\n  min-height: 100px;\n  margin:auto;\n  font-size: 40px;\n}\n\n.input{\n  min-width: 100%;\n  min-height: 100px;\n  margin:auto;\n  font-size: 40px;\n}\n\n.error{\n  font-size: 40px;\n  color: red;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n\n#header{\n  background: rgb(45,200,187);\n  color: white;\n  font-size: 15px;\n}\n\n#logindev{\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/hihoo/ibilling/attendence/public/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = 1